/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

import Axios from 'axios'

// Vue Router
import router from './routes/router'

// Vuex Store
import store from './store/store'

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
Vue.use(PerfectScrollbar);

Vue.prototype.$http = Axios;
const token = localStorage.getItem('access-token');
if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
});

// import VueDatePicker from '@mathieustan/vue-datepicker';
// Vue.use(VueDatePicker, { lang: 'en' });

Vue.config.productionTip = false;

const mountEl = document.querySelector("#app");

Vue.prototype.localize = function (str) {
    if (this.$store.state.currentTranslations && str in this.$store.state.currentTranslations) {
        return this.$store.state.currentTranslations[str];
    }
    return str;
}

new Vue({
    router,
    store,
    render: h => h(App, {
        props:{
            organization_id: parseInt(document.querySelector("#app").dataset.organizationId)
        }
    })
}).$mount('#app');
